import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.png'
import TeamSection from '../../components/TeamSection/TeamSection';
import SEO from '../../components/Seo';


const TeamPage = () => {
    return (
        <Fragment>
            <SEO
                title="Our Team | LuxRock Realty Real Estate Experts"
                description="Meet the professional real estate consultants of LuxRock Realty. Our experienced property advisors help you buy, sell and invest safely."
                keywords="LuxRock Realty team, real estate agents, property consultants, real estate experts surat"
            />
            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={'People You Can Trust With Your Property'} pagesub={'Team'} />
            <ScrollTextAnimation />
            <TeamSection hclass={'wpo-team-section'} />
            <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TeamPage;



